<script setup lang="ts">
interface Props {
  /** Icon name to display */
  icon: string
  /** Label text for the menu item */
  label: string
}

defineProps<Props>()
</script>

<template>
  <button type="button" class="action-menu-item">
    <VIcon :icon size="1.125rem" class="mr-2 text-secondary-600" />
    {{ label }}
  </button>
</template>

<style lang="scss" scoped>
@reference '../../../styles/main.css';

.action-menu-item {
  @apply flex w-full flex-row items-center whitespace-nowrap;
  @apply bg-transparent px-3 py-2;
  @apply font-secondary text-sm;
  @apply hover:bg-secondary-100;
}
</style>
